










import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component({
  components: {
  }
})
export default class PagePagination extends Vue {
  @Prop({
    type: Number,
    default: 0
  }) private readonly total!: number;

  @Prop({
    type: Number,
    default: 0
  }) private readonly perPage!: number;

  @Prop({
    type: Number,
    default: 0
  }) private readonly page!: number;

  @Prop({
    type: Number,
    default: 0
  }) private readonly pageCount!: number;

  onChange (page: number): void {
    this.$emit('change', page)
  }
}
